import script from "./SkyLoading.vue?vue&type=script&setup=true&lang=js"
export * from "./SkyLoading.vue?vue&type=script&setup=true&lang=js"

import "./SkyLoading.vue?vue&type=style&index=0&id=22feb6f2&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-22feb6f2"]])

export default __exports__